"use strict";

require('./CompanyPublicationFileService.js');
require('../categories/CompanyCategoryService.js');
require('./PublicationChecklistDirective.js');
require('./CompanyPublicationKeypassCtrl.js');
require('./plant/CompanyPublicationPlantCtrl.js');
require('./order/CompanyPublicationOrderCtrl.js');
require('./companyOrder/CompanyPublicationCompanyOrderCtrl.js');
require('./companyOrder/CompanyPublicationCompanyOrderEditCtrl.js');
require('./investigation/CompanyPublicationCompanyInvestigationCtrl.js');
require('./order/CompanyPublicationOrderService.js');
require('./albumViewDirective.js');
require('../checklist/CompanyChecklistService.js');
require('../products/CompanyProductsService.js');
require('../customers/CompanyCustomersService.js');
require('./companyOrder/CompanyPublicationCompanyOrderService.js');
require('./companyOrderSubcription/CompanyPublicationCompanyOrderSubcriptionService.js');
require('./investigation/CompanyPublicationCompanyInvestigationService.js');
require('./investigation/CompanyInvestigationPagesService.js');
require('./internalMessageDirective.js');
require('./blogs/CompanyPublicationBlogService.js');
require('./blogs/CompanyPublicationBlogCtrl');
require('./CompanyPublicationEditFileContentDirective.js');
require('../notices/CompanyNoticeNewCtrl.js');
require('../notices/CompanyNoticeDetailCtrl.js');
require('../notices/CompanyNoticeService.js');
require('../settings/CompanySettingInvestigationUsersService.js');
require('../settings/CompanySettingInvestigationTemplatesService.js');
require('../account/CompanyFlowVerifiesService.js');
require('./CompanyPublicationCertifyDocCtrl.js');
var moment = require('moment');

CompanyPublicationDetailCtrl.$inject = [
  "$scope",
  "$state",
  "$window",
  "$interval",
  "$stateParams",
  "$translate",
  "translations",
  "$q",
  "config",
  "publication",
  "growl",
  "data",
  "UploadTracker",
  "currentUser",
  "CompanyNoticeService",
  "CompanyPublicationFileService",
  "CompanyCategoryService",
  "CompanyPublicationService",
  "CompanyUserService",
  "CompanyChecklistService",
  "CompanyCustomersService",
  "CompanyPublicationOrderService",
  "CompanyPublicationCompanyOrderService",
  "CompanyPublicationCompanyOrderSubcriptionService",
  "CompanyPublicationCompanyInvestigationService",
  "CompanyFlowVerifiesService",
  "$modal",
  "$rootScope"
];
function CompanyPublicationDetailCtrl (
  $scope,
  $state,
  $window,
  $interval,
  $stateParams,
  $translate,
  translations,
  $q,
  config,
  publication,
  growl,
  data,
  uploadTracker,
  currentUser,
  CompanyNoticeService,
  CompanyPublicationFileService,
  CompanyCategoryService,
  CompanyPublicationService,
  CompanyUserService,
  checklistService,
  customersService,
  orderService,
  publicationCompanyOrderService,
  publicationCompanyOrderSubcriptionService,
  CompanyPublicationCompanyInvestigationService,
  CompanyFlowVerifiesService,
  $modal,
  $rootScope
) {
  $scope.publication  = publication;
  $scope.currentUser  = currentUser;
  $scope.showFileDrop = false;
  $scope.isEdited = false;

  delete $rootScope.tinymceOptions.file_picker_callback;

  $rootScope.tinymceOptions.images_upload_handler = function (blobInfo, success, failure) {
    var files = [blobInfo.blob()];
    if(files && files.length > 0){
      uploadTracker(files.map(function(f) {
        return {
          url:  config.apiBase + "/companies/" + $stateParams.companyId + "/publications/"+$stateParams.publicationId+"/files",
          file: f
        };
      })).then(function(headers){
        var newId = headers[0].split('/').pop();
        var imageUrl = config.apiBase + '/files/' + newId;
        success(imageUrl)
      });
    }
  };
          
  $rootScope.tinymceOptions.file_picker_callback = function(callback, value, meta) {  
    if (meta.filetype === 'image') {
      $('#upload').trigger('click');
      $('#upload').on('change', function() {
        var files = new Array(this.files);
        if(files && files.length > 0){
          uploadTracker(files.map(function(f) {
            return {
              url:  config.apiBase + "/companies/" + $stateParams.companyId + "/publications/"+$stateParams.publicationId+"/files",
              file: f[0],
            };
          })).then(function(headers){
            var newId = headers[0].split('/').pop();
            var imageUrl = config.apiBase + '/files/' + newId;
            callback(imageUrl, {
              alt: ''
            });
          });
        }
      });
    }
  };

  $scope.downloadZip = function() {
    var iOS = /(iPad|iPhone|iPod)/g.test(navigator.userAgent);
    if (true === iOS) {
      window.open(config.apiBase + '/companies/' + $scope.companyId + '/publications/' + $stateParams.publicationId + '/zip?lang=' + window.localStorage.language, '_self');
      return;
    }

    var elm = angular.element(document.querySelector('body'));
    var iFrame = elm.find('#downloadWindow');
    if (!(iFrame && iFrame.length > 0)) {
      iFrame = angular.element("<iframe id='downloadWindow' style='position:fixed;display:none;top:-1px;left:-1px;'/>");
      elm.append(iFrame);
    }

    iFrame.attr(
      'src',
      config.apiBase + '/companies/' + $scope.companyId + '/publications/' + $stateParams.publicationId + '/zip?lang=' + window.localStorage.language
    );
  };

  $scope.showNoticeModal = function() {
    var modal = $modal({
      scope: $scope,
      controller: 'CompanyNoticeNewCtrl',
      templateUrl: 'partials/company/notices/modal-new.html',
      resolve: {
        noticeCategories: ['$stateParams', 'CompanyCategoryService', function($stateParams, CompanyCategoryService) {
          return CompanyCategoryService.query({companyId: $stateParams.companyId, type: 'REMINDER_CATEGORY'}).$promise;
        }]
      },
      show: false
    });
    modal.$promise.then(modal.show);
  };

  var modalList;
  $scope.showNoticeListModal = function() {
    $rootScope.loading = true;
    modalList = $modal({
      scope: $scope,
      templateUrl: 'partials/company/notices/modal-list.html',
      show: false,
      controller: ['notices', '$scope', '$stateParams', function(notices, $scope, $stateParams){
        $scope.notices = notices;
        $scope.filterCompleted = false;
        $scope.searchNotices = function(){
          CompanyNoticeService.query({
            companyId: $stateParams.companyId, 
            publicationId: $stateParams.publicationId, 
            completed: $scope.filterCompleted, 
            limit: 1000
          }).$promise.then(function(notices){
            $scope.notices = notices;
          });
        };
      }],
      prefixEvent: 'noticListModal',
      resolve: {
        notices: function() {
          return CompanyNoticeService.query({
            companyId: $stateParams.companyId, 
            publicationId: $stateParams.publicationId, 
            completed: false, 
            limit: 1000
          }).$promise;
        }
      }
    });
    modalList.$promise.then(function(){
      modalList.show();
      $rootScope.loading = false;
    });
  };

  var noticeDetailModal;
  $scope.showNoticeDetailModal = function(notice) {
    $rootScope.loading = true;
    if (typeof modalList === 'object') {
      modalList.$promise.then(modalList.hide);
    }

    noticeDetailModal = $modal({
      scope: $scope,
      controller: 'CompanyNoticeDetailCtrl',
      templateUrl: 'partials/company/notices/modal-detail.html',
      show: false,
      prefixEvent: 'noticeDetailModal',
      resolve: {
        notice: function() {
          return notice;
        },
        noticeCategories: ['$stateParams', 'CompanyCategoryService', function($stateParams, CompanyCategoryService) {
          return CompanyCategoryService.query({companyId: $stateParams.companyId, type: 'REMINDER_CATEGORY'}).$promise;
        }]
      }
    });

    noticeDetailModal.$promise.then(function(){
      $rootScope.loading = false;
      noticeDetailModal.show();
    });
  };

  $scope.$on('noticeDetailModal', function(){
    if (typeof noticeDetailModal === 'object') {
      noticeDetailModal.destroy();
      noticeDetailModal = null;
    }
  });

  $scope.$on('prefixEvent.hide', function(){
    if (typeof modalList === 'object') {
      modalList.destroy();
      modalList = null;
    }
  });

  $scope.showCertifyDocModal = function() {
    var modal = $modal({
      scope: $scope,
      controller: 'CompanyPublicationCertifyDocCtrl',
      templateUrl: 'partials/company/publications/detail/certify-doc.html',
      show: false
    });
    modal.$promise.then(modal.show);
  };

  function string2array(str) {
    if(typeof str !== "string") {
      return [];
    }

    var data = JSON.parse(str);

    return angular.isArray(data) ? data : [];
  }

  var setFileVisibility = function(file, visibility) {
    CompanyPublicationFileService.update({
      companyId:     $stateParams.companyId,
      publicationId: $stateParams.publicationId,
      fileId:        file.id
    }, {
      visible: visibility
    }).$promise.then(function() {
      file.visible = visibility;

      var idx = $scope.files.indexOf(file);

      if(idx !== -1) {
        $scope.files.splice(idx, 1);
      }

      $scope.$broadcast("files-uploaded");
    }, function() {
      growl.addErrorMessage();
    });
  };

  var queryFiles =  function() {
    return CompanyPublicationFileService.query({
      companyId:     $stateParams.companyId,
      publicationId: $stateParams.publicationId,
      limit:         21,
      visible:       $stateParams.showInvisible === "true" ? "false" : "true",
      offset:        ($stateParams.page|0) * 20
    }).$promise.then(function(files) {
      $scope.$emit('publicationSaved');
      $scope.files   = files.slice(0, 20);
      $scope.hasMore = files.length > 20;
    });
  };



  var queryAllFiles =  function() {
    return CompanyPublicationFileService.query({
      companyId:     $stateParams.companyId,
      publicationId: $stateParams.publicationId,
      limit:         21,
      offset:        ($stateParams.page|0) * 20
    }).$promise.then(function(files) {
      $scope.$emit('publicationSaved');
      $scope.files   = files.slice(0, 20);
      $scope.hasMore = files.length > 20;
    });
  };

  var queryPublicationsChildren = function(text) {
      return CompanyPublicationService.query({
        companyId: $stateParams.companyId,
        q:         text,
        limit:     10
      }).$promise.then(function(p) {
        return p.filter(function(p) {
          return !$scope.children.some(function(publication) {
            return publication.id === p.id;
          });
        });
      });
    };

  var addChildrenConnected = function(object){
    var children = new CompanyPublicationService(object);

    children.parent = {
      id:   $scope.publication.id,
      name: $scope.publication.name
    };

    children.$update({
      companyId: $stateParams.companyId,
      publicationId: children.id
    }, function(){
      $scope.children = $scope.children.concat(object);
    });

  };

  $scope.deleteFileInDraftMode = function(file, publicationId) {
    CompanyPublicationFileService.delete(
      {
        companyId: $stateParams.companyId,
        publicationId: publicationId,
        fileId: file.id
      },
      function(){
        $scope.currentFile = false;
        growl.addSuccessMessage(translations['publication.delete-file-success']);
      },
      function(){
        growl.addErrorMessage(translations['publication.delete-file-failure']);
      });
  };

  // Add customer to publication
  $scope.queryCustomers = function(text) {
    return customersService.query({
      companyId: $stateParams.companyId,
      q:         text,
      limit:     10
    }).$promise.then(function(p) {
      return p.filter(function(p) {
        if (!$scope.order) {
          return true;
        }
        return ![$scope.order.customer].some(function(publication) {
          return publication.id === p.id;
        });
      });
    });
  };

  $scope.$on('orderChanged', function (event, data) {
    $scope.order = data;
  });

  $scope.addCustomer = function(customer) {

    var customerDeferred = $q.defer();
    if ($scope.publication.features.currentCustomerId) {
      customersService.removeObject({
        companyId: $stateParams.companyId,
        objectId: $scope.publication.id,
        customerId: customer.id
      }, function(){
        customerDeferred.resolve();
      }, function(){
        customerDeferred.resolve();
      });
    } else {
      customerDeferred.resolve();
    }

    customerDeferred.promise.then(function(){
      customersService.addObject({
        companyId: $stateParams.companyId,
        customerId: customer.id
      }, {
        object: {
          id: publication.id,
          name: publication.name
        }
      }, function(){
        $scope.publication.features.currentCustomerId = customer.id;
        $scope.savePublication($scope.publication);
        customersService.get({
          companyId: $stateParams.companyId,
          publicationId: $scope.publication.id,
          customerId: customer.id
        }, function(resp){
          $scope.connectedCustomer = angular.copy(resp);
        });
      });
    });


    if (publication.type === 'COMPANY_ORDER' || publication.type === 'ORDER_SUBCRIPTION' || publication.type === 'ORDER') {
      var data = {
        customer: customer
      };

      if (publication.type === 'COMPANY_ORDER' || publication.type === 'ORDER_SUBCRIPTION') {
        data.publication = {
          name: $scope.publication.name,
          id: $scope.publication.id
        };
      } else {
        data.publicationId = $scope.publication.id;
      }

      if ($scope.order) {
        data = angular.copy($scope.order);
        data.customer = customer;
      }

      if (publication.type === 'COMPANY_ORDER' || publication.type === 'ORDER_SUBCRIPTION') {
        if ($scope.order) {
          data.status = $scope.order.status;
        } else {
          data.status = 'CART';
        }
        if(publication.type === 'COMPANY_ORDER'){
          publicationCompanyOrderService.update({
            companyId: $stateParams.companyId,
            publicationId: $stateParams.publicationId
          }, data).$promise.then(function(order){
            $scope.order = angular.copy(order);
            $scope.$parent.order = $scope.order;
            $scope.$broadcast('customerChanged');
            $scope.$broadcast('showCustomerInfo');
            $scope.publication.features.currentCompanyOrderId = $scope.order.id;
            $scope.savePublication($scope.publication);
          }).then(function(){
            growl.addSuccessMessage($translate.instant('order.customer.add-success'));
          }, function(){
            growl.addErrorMessage($translate.instant('order.customer.add-failure'));
          });
        }else{
          publicationCompanyOrderSubcriptionService.update({
            companyId: $stateParams.companyId,
            publicationId: $stateParams.publicationId
          }, data).$promise.then(function(order){
            $scope.order = angular.copy(order);
            var subcription            = $scope.order.interval.split(' ');
            $scope.order.subcriptionNumber   = parseInt(subcription[0]);
            $scope.order.optionSubcription   = subcription[1][subcription[1].length-1] === 's' ? subcription[1].substring(0, subcription[1].length-1) : subcription[1];
            if(!$scope.order.lastGenAt){
              $scope.order.lastGenAt = $scope.order.createdAt;
            }
            if($scope.order.startAt >= $scope.order.lastGenAt){
              $scope.order.nextCreatedOrder = moment($scope.order.startAt).add(parseInt($scope.order.subcriptionNumber), $scope.order.optionSubcription+($scope.order.optionSubcription === 'mon' ? 'ths':'s')).format('YYYY MM DD');
            }else{
              $scope.order.nextCreatedOrder = moment($scope.order.lastGenAt).add(parseInt($scope.order.subcriptionNumber), $scope.order.optionSubcription+($scope.order.optionSubcription === 'mon' ? 'ths':'s')).format('YYYY MM DD');
            }
            $scope.$parent.order = $scope.order;
            $scope.$broadcast('customerChanged');
            $scope.$broadcast('showCustomerInfo');
            $scope.publication.features.currentCompanyOrderId = $scope.order.id;
            $scope.savePublication($scope.publication);
          }).then(function(){
            growl.addSuccessMessage($translate.instant('order.customer.add-success'));
          }, function(){
            growl.addErrorMessage($translate.instant('order.customer.add-failure'));
          });
        }
      } else if (publication.type === 'ORDER') {
        orderService.update({
          companyId: $stateParams.companyId,
          publicationId: $stateParams.publicationId
        }, data).$promise.then(function(order){
          $scope.order = angular.copy(order);
          $scope.publication.features.currentOrderId = $scope.order.id;
          $scope.savePublication($scope.publication);
        }).then(function() {
          growl.addSuccessMessage($translate.instant('order.customer.add-success'));
        },
        function() {
          growl.addErrorMessage($translate.instant('order.customer.add-failure'));
        });
      }
    }
  };

  $scope.editting = false;
  $scope.dataEdit = null;
  $scope.$on('edittingObject', function(e, data){
    $scope.$apply(function(){
      if(data.name === 'EDITTING' && currentUser.id !== data.user.id && publication.id === data.object.id){
        $scope.editting = true;
        $scope.dataEdit = data;
      }else{
        $scope.editting = false;
        $scope.dataEdit = null;
      }
    });
  });

  $scope.$on('customerOrder100', function(evt, data){
    $scope.addCustomer(data);
  });

  $scope.searchFileStr = $stateParams.searchFile || "";

  $scope.changeDes = function(){
    if($scope.publication.type === 'DEFAULT'){
        $window.localStorage.editPublicationDefault = JSON.stringify($scope.publication);
      }else{
        if($scope.publication.type === 'BLOG'){
          $scope.publication.posts = $scope.posts;
          $window.localStorage.editPublicationBlog = JSON.stringify($scope.publication);
        }else{
          if($scope.publication.type === 'ALBUM'){
            $window.localStorage.editPublicationAlbum = JSON.stringify($scope.publication);
          }else{
            if($scope.publication.type === 'NOTE'){
              $window.localStorage.editPublicationNote = JSON.stringify($scope.publication);
            }else{
              if($scope.publication.type === 'SK3_FOLDER'){
                $window.localStorage.editPublicationSK3 = JSON.stringify($scope.publication);
              }
            }
          }
        }
      }
  };
  $scope.setStorageDescription = function(){
    if($scope.publication.type === 'DEFAULT'){
      delete $window.localStorage.editPublicationDefault;
    }else{
      if($scope.publication.type === 'BLOG'){
        delete $window.localStorage.editPublicationBlog;
      }else{
        if($scope.publication.type === 'ALBUM'){
          delete $window.localStorage.editPublicationAlbum;
        }else{
          if($scope.publication.type === 'NOTE'){
            delete $window.localStorage.editPublicationNote;
          }else{
            if($scope.publication.type === 'SK3_FOLDER'){
              delete $window.localStorage.editPublicationSK3;
            }
          }
        }
      }
    }
  };

  switch(publication.type) {
    case 'ALBUM':
      if($window.localStorage.editPublicationAlbum){
        var editPublicationAlbum = JSON.parse($window.localStorage.editPublicationAlbum);
        if(editPublicationAlbum.id === $scope.publication.id){
          $scope.publication.description = editPublicationAlbum.description;
          $scope.togglePublicationForm = true;
        }
      }
    case 'CUSTOMER_ADAPTION':
      $scope.detailsViewTemplate = 'partials/company/publications/detail/latest/' + publication.type.toLowerCase() + '.html';
      if($scope.info.features.documentReminder && $scope.currentUserPermissions.DocumentReminderList){
        CompanyNoticeService.query({companyId: $stateParams.companyId, publicationId: $stateParams.publicationId, limit: 2, offset: 0}).$promise.then(function(notices){
          $scope.notices = notices;
        });
      }
      $scope.files               = data.files.slice(0, 21);
      $scope.checklists          = data.checklists;
      $scope.showInvisibleFiles  = $stateParams.showInvisible === "true";
      $scope.showFileDrop        = !$scope.showInvisibleFiles;
      $scope.currentPage         = $stateParams.page|0;
      $scope.hasMore             = data.files.length > 21;
      $scope.setFileVisibility   = setFileVisibility;
      $scope.$on("files-uploaded", queryFiles);
      break;

    case 'FOLDER':
      $scope.detailsViewTemplate = 'partials/company/publications/detail/latest/folder.html';
      $scope.children            = data.children;
      $scope.checklists          = data.checklists;
      $scope.files               = data.files.slice(0, 21);
      $scope.connectedCustomer   = data.customer;
      $scope.showInvisibleFiles  = $stateParams.showInvisible === "true";
      $scope.showFileDrop        = !$scope.showInvisibleFiles;
      $scope.currentPage         = $stateParams.page|0;
      $scope.hasMore             = data.files.length > 21;
      $scope.setFileVisibility = setFileVisibility;
      $scope.addChildrenConnected = addChildrenConnected;
      $scope.queryPublicationsChildren = queryPublicationsChildren;
      $scope.$on("files-uploaded", queryFiles);
      break;

    case 'PUBLICATION_GROUP':
      $scope.detailsViewTemplate = 'partials/company/publications/detail/latest/publication-group.html';
      $scope.children            = data.children;
      $scope.currentFile         = data.currentFile;
      $scope.connectedCustomer   = data.customer;
      $scope.showFileDrop        = true;

      $scope.addChildrenConnected = addChildrenConnected;

      $scope.queryPublicationsChildren = queryPublicationsChildren;

      $scope.$on("files-uploaded", function() {
        CompanyPublicationFileService.query({
          companyId:     $stateParams.companyId,
          publicationId: $stateParams.publicationId,
          limit:         1
        }).$promise.then(function(files) {
          $scope.currentFile = files[0] || false;
          if ($scope.currentFile) {
            $scope.$broadcast('fileProcessed', $scope.currentFile);
            $scope.$emit('publicationSaved');
          }
        });
      });
      break;

    case 'NOTE':
      $scope.detailsViewTemplate = 'partials/company/publications/detail/latest/notes.html';

      $scope.editForm = false;
      $scope.masterPublicationDescription = angular.copy($scope.publication.description);
      $scope.masterPublicationTitle = angular.copy($scope.publication.name);
      $scope.logoPdf = data.logoPdf;
      if($window.localStorage.editPublicationNote){
        var editPublicationNote = JSON.parse($window.localStorage.editPublicationNote);
        if(editPublicationNote.id === $scope.publication.id){
          $scope.publication.description = editPublicationNote.description;
          $scope.togglePublicationForm = true;
        }
      }

      $rootScope.tinymceOptions.file_picker_types = 'image';

      $scope.createCard = function(publicationType) {
        $scope.cardCreating = true;
        CompanyPublicationService.createCard({
          companyId: $stateParams.companyId,
          id: $stateParams.publicationId,
          target: publicationType ? publicationType : 'CARD'
        }, function(response, headers) {
          var id = headers('Location').split('/').pop();
          var url = "/companies/" + $stateParams.companyId + "/publications/" + id;
          growl.addErrorMessage($translate.instant('publication.create-card.create-success'), null, url);
          $scope.cardCreating  = false;
          // window.location.href = "/companies/" + $stateParams.companyId + "/publications/" + id
        }, function() {
          $scope.cardCreating  = false;
          growl.addErrorMessage($translate.instant('publication.create-card.create-failure'));

        })
      }

      $scope.copyPublication = function(){
        CompanyPublicationService.copyObject({
          companyId: $stateParams.companyId,
          publicationId: $stateParams.publicationId
        }, {}, function(resp, headers){
          growl.addSuccessMessage($translate.instant('order.create-all-copies-success'));
          var newId = headers('Location').split('/').pop();
          $state.go('root.company.publication.detail', {companyId: $stateParams.companyId, publicationId: newId});
        }, function(){
          growl.addErrorMessage($translate.instant('order.create-all-copies-failure'));
        });
      };

      $scope.savePublicationNote = function() {
        if ($scope.publication.name === '') {
          $scope.publication.name = $scope.masterPublicationTitle;
        }
        if ($scope.publication.description === '') {
          $scope.publication.description = $scope.masterPublicationDescription;
        }
        $scope.editFormWaiting = true;
        $scope.savePublication($scope.publication).then(function() {
          $scope.editForm = false;
          $scope.editFormWaiting = false;
          $scope.$$childHead.publicationForm.$setPristine();
          $scope.masterPublicationDescription = angular.copy($scope.publication.description);
          $scope.masterPublicationTitle = angular.copy($scope.publication.name);
          $scope.stopAutoSave();
        },function(data){
          $scope.editFormWaiting = false;
          $scope.stopAutoSave();
          if (data.status === 304) {
            $scope.editForm = false;
          }
        });
      };


      $scope.cancelEditNote = function() {
        $scope.publication.description = $scope.masterPublicationDescription;
        $scope.publication.name = $scope.masterPublicationTitle;
        $scope.stopAutoSave();
      };

      $scope.children            = data.children;
      $scope.checklists          = data.checklists;
      var stopSave;
      $scope.autoSave = function() {
        stopSave = $interval(function(){
          if ($scope.$$childHead.publicationForm.$dirty) {
            $scope.savePublication($scope.publication).then(function(){
              $scope.masterPublicationDescription = $scope.publication.description;
              $scope.masterPublicationTitle = $scope.publication.name;
              $scope.$$childHead.publicationForm.$setPristine();
            });
          }
        }, 300000);
      };

      $scope.stopAutoSave = function() {
        if (angular.isDefined(stopSave)) {
            $interval.cancel(stopSave);
            stopSave = undefined;
          }
      };

      $scope.$on('$destroy', function() {
        $scope.stopAutoSave();
      });

      $scope.$watch("editForm", function(newData, oldData){
        if (newData === true && newData !== oldData) {
          $scope.autoSave();
        }
      }, true);

      break;
    case 'KEYPASS':
      $scope.detailsViewTemplate = 'partials/company/publications/detail/latest/keypass.html';
      break;
    case 'MASTERFILE':
      $scope.detailsViewTemplate = 'partials/company/publications/detail/latest/masterfile.html';
      $scope.currentFile         = data.files;
      $scope.showFileDrop        = true;

      $scope.$watch("publication", function(data){
        $scope.fileCheckout = string2array(data.features.fileCheckout);
        if ($scope.fileCheckout.length > 0) {
          CompanyUserService.get({
            companyId: $stateParams.companyId,
            publicationId: $stateParams.publicationId,
            userId: $scope.fileCheckout[0].userId})
          .$promise.then(function(resp){
            $scope.userCheckout = resp.name;
          });
        }
      });
      $scope.$on("files-uploaded", function() {
        CompanyPublicationFileService.query({
          companyId:     $stateParams.companyId,
          publicationId: $stateParams.publicationId,
          limit:         1
        }).$promise.then(function(files) {
          $scope.currentFile = files[0] || false;
          if ($scope.currentFile) {
            CompanyPublicationService.get({companyId: $stateParams.companyId, publicationId: $stateParams.publicationId}).$promise.then(function(resp){
              $scope.$parent.publication = resp;
              $scope.publication = resp;
            });
            $scope.$broadcast('fileProcessed', $scope.currentFile);
            $scope.$emit('publicationSaved');
          }
        });
      });
      break;
    case 'WALL':
      $scope.detailsViewTemplate = 'partials/company/publications/detail/latest/wall.html';
      $scope.showFileDrop = false;
      break;

    case 'PLANT':
      $scope.detailsViewTemplate = 'partials/company/publications/detail/latest/plant.html';
      $scope.showFileDrop = true;
      $scope.currentFile         = data.currentFile;
      $scope.plant = data.plant;

      $scope.$on("files-uploaded", function() {
        CompanyPublicationFileService.query({
          companyId:     $stateParams.companyId,
          publicationId: $stateParams.publicationId,
          limit:         1
        }).$promise.then(function(files) {
          $scope.currentFile = files[0] || false;
          if ($scope.currentFile) {
            $scope.$broadcast('fileProcessed', $scope.currentFile);
            $scope.$emit('publicationSaved');
          }
        });
      });
      break;

    case 'ORDER':
      $scope.detailsViewTemplate = 'partials/company/publications/detail/latest/order.html';
      $scope.showFileDrop = false;
      $scope.order = data;
      break;

    case 'ENGINE_MODEL':
      $scope.detailsViewTemplate = 'partials/company/publications/detail/latest/engine-model.html';
      $scope.currentFile         = data;
      $scope.showFileDrop        = true;

      $scope.$on("files-uploaded", function() {
        CompanyPublicationFileService.query({
          companyId:     $stateParams.companyId,
          publicationId: $stateParams.publicationId,
          limit:         1
        }).$promise.then(function(files) {
          $scope.currentFile = files[0] || false;
          if ($scope.currentFile) {
            $scope.$broadcast('fileProcessed', $scope.currentFile);
            $scope.$emit('publicationSaved');
          }
        });
      });

      break;

    case 'COMPANY_ORDER':
      $scope.detailsViewTemplate = 'partials/company/publications/detail/latest/company-order.html';
      $scope.files               = data.files.slice(0, 21);
      $scope.checklists          = data.checklists;
      $scope.showInvisibleFiles  = $stateParams.showInvisible === "true";
      $scope.showFileDrop        = !$scope.showInvisibleFiles;
      $scope.currentPage         = $stateParams.page|0;
      $scope.hasMore             = data.files.length > 21;
      $scope.setFileVisibility   = setFileVisibility;
      $scope.$on("files-uploaded", queryFiles);
      break;
    case 'ORDER_SUBCRIPTION':
      $scope.detailsViewTemplate = 'partials/company/publications/detail/latest/order-subscription.html';
      $scope.files               = data.files.slice(0, 21);
      $scope.checklists          = data.checklists;
      $scope.showInvisibleFiles  = $stateParams.showInvisible === "true";
      $scope.showFileDrop        = !$scope.showInvisibleFiles;
      $scope.currentPage         = $stateParams.page|0;
      $scope.hasMore             = data.files.length > 21;
      $scope.setFileVisibility   = setFileVisibility;
      $scope.children = data.children;
      $scope.$on("files-uploaded", queryFiles);
      break;
    case 'BLOG':
      $scope.detailsViewTemplate = 'partials/company/publications/detail/latest/blog.html';
      $scope.posts               = data.slice(0, 21);
      $scope.currentPage         = $stateParams.page|0;
      $scope.hasMore             = data.length > 21;
      $scope.showFileDrop        = true;
      if($window.localStorage.editPublicationBlog){
        var editPublicationBlog = JSON.parse($window.localStorage.editPublicationBlog);
        if(editPublicationBlog.id === $scope.publication.id){
          $scope.posts = editPublicationBlog.posts;
          $scope.togglePublicationForm = true;
        }
      }
      break;
    case 'INVESTIGATION':
      $scope.detailsViewTemplate = 'partials/company/publications/detail/latest/investigation.html';

      $scope.showInvisibleFiles  = $stateParams.showInvisible === "true";
      $scope.showFileDrop        = !$scope.showInvisibleFiles;
      $scope.currentPage         = $stateParams.page|0;
      $scope.setFileVisibility   = setFileVisibility;
      if(!$scope.investigation.publicationIds){
        $scope.investigation.publicationIds = [];
      }

      $scope.updateInvestigation = function(start, step, decision) {
        if($scope.investigation.id){
          CompanyPublicationCompanyInvestigationService.update({
            companyId: $stateParams.companyId,
            publicationId: $stateParams.publicationId,
            start: start ? true : null,
            step: step ? step : null,
            decision: decision ? decision : null
          }, $scope.investigation, function(){
            growl.addSuccessMessage($translate.instant('investigation.update-success'));
          }, function(){
            growl.addErrorMessage($translate.instant('investigation.update-failure'));
          });
        }else{
          CompanyPublicationCompanyInvestigationService.save({
            companyId: $stateParams.companyId,
            publicationId: $stateParams.publicationId,
            start: start ? true : null,
            step: step ? step : null,
            decision: decision ? decision : null
          }, $scope.investigation, function(investigation){
            growl.addSuccessMessage($translate.instant('investigation.update-success'));
            $scope.investigation = investigation;
            $scope.investigation.status = 'OPEN';
          }, function(){
            growl.addErrorMessage($translate.instant('investigation.update-failure'));
          });
        }
        if($scope.invesUsers[2].users.length > 0 && $scope.invesUsers[3].users.length > 0 && $scope.investigation.partnerAddress && $scope.investigation.invesDate){
          $scope.investigationSteps[0].success = true;
        }
      };

      $scope.invesUsers = [{
        name: $translate.instant('investigation.deferred-to-incident'),
        users: data.invesUsersUtsatt,
        type: 'UTSATT',
        relativeType: '',
        checklists: null
      },{
        name: $translate.instant('investigation.suspected-involvement'),
        users: data.invesUsersMissTankt,
        type: 'MISS_TANKT',
        relativeType: '',
        checklists: null
      },{
        name: $translate.instant('investigation.responsible-investigator'),
        users: data.invesUsersAnvarig,
        type: 'ANVARIG',
        relativeType: 'INVESTIGATON_ANVARIG',
        checklists: data.anvarigChecklists
      },{
        name: $translate.instant('investigation.engaged-personnel'),
        users: data.invesUsersEngagerad,
        type: 'ENGAGERAD',
        relativeType: 'INVESTIGATON_ENGAGERAD',
        checklists: data.engageradChecklists
      }];
      $scope.invesUsersBetslut = data.invesUsersBetslut;

      $rootScope.investigationInfors = data.investigationInfors;
      $scope.investigationSanmanInfors = data.investigationSanmanInfors;
      if(data.investigationBetslutInfors.length > 0){
        $scope.investigationBetslutInfors = data.investigationBetslutInfors[0];
      }else{
        $scope.investigationBetslutInfors = {
          type: 'BETSLUT',
          partner: 'default',
          periodUp: '14 days',
          telephoneMode: false,
          personlightMode: false,
          varnadDate: new Date(),
          content: '',
          extra: {
            selectdPart1: [],
            selectdPart2: []
          },
          template: null
        };
      }
      $scope.portals = data.portals;

      $scope.part1Users = data.invesUsersUtsatt.concat(data.invesUsersMissTankt);
      $scope.part2Users = data.invesUsersAnvarig.concat(data.invesUsersEngagerad);

      if(data.invesUsersEngagerad.length > 0 && data.invesUsersAnvarig.length > 0 && $scope.investigation.partnerAddress && $scope.investigation.invesDate){
        $scope.investigationSteps[0].success = true;
      }

      if(data.investigationInfors.length > 0){
        $scope.investigationSteps[1].success = true;
      }
      if(data.investigationSanmanInfors.length > 0){
        $scope.investigationSteps[2].success = true;
      }

      $scope.investigationUsers = data.investigationUsers;
      $scope.investigationTemplates = data.investigationTemplates;
      $scope.investigationPages = data.investigationPages;

      break;
    case 'SK3_FOLDER':
      $scope.detailsViewTemplate = 'partials/company/publications/detail/latest/sk3-folder.html';
      $scope.albumTemplate = 'partials/company/publications/detail/latest/album-view/list.html';
      if($window.localStorage.editPublicationSK3){
        var editPublicationSK3 = JSON.parse($window.localStorage.editPublicationSK3);
        if(editPublicationSK3.id === $scope.publication.id){
          $scope.publication.description = editPublicationSK3.description;
          $scope.togglePublicationForm = true;
        }
      }
      if($scope.info.features.documentReminder && $scope.currentUserPermissions.DocumentReminderList){
        CompanyNoticeService.query({companyId: $stateParams.companyId, publicationId: $stateParams.publicationId, limit: 2, offset: 0}).$promise.then(function(notices){
          $scope.notices = notices;
        });
      }
      $scope.files               = data.files.slice(0, 21);
      $scope.checklists          = data.checklists;
      $scope.showInvisibleFiles  = $stateParams.showInvisible === "true";
      $scope.showFileDrop        = !$scope.showInvisibleFiles;
      $scope.currentPage         = $stateParams.page|0;
      $scope.hasMore             = data.files.length > 21;
      $scope.setFileVisibility   = setFileVisibility;
      $scope.$on("files-uploaded", queryAllFiles);
      break;

    default:
      $scope.detailsViewTemplate = 'partials/company/publications/detail/latest/default.html';
      if($scope.info.features.documentReminder && $scope.currentUserPermissions.DocumentReminderList){
        CompanyNoticeService.query({companyId: $stateParams.companyId, publicationId: $stateParams.publicationId, limit: 2, offset: 0}).$promise.then(function(notices){
          $scope.notices = notices;
        });
      }


      $scope.currentFile         = data.files;
      $scope.checklists          = data.checklists;
      $scope.showFileDrop        = true;
      $scope.currentUser         = currentUser;
      if($window.localStorage.editPublicationDefault){
        var editPublicationDefault = JSON.parse($window.localStorage.editPublicationDefault);
        if(editPublicationDefault.id === $scope.publication.id){
          $scope.publication.description = editPublicationDefault.description;
          $scope.togglePublicationForm = true;
        }
      }

      CompanyFlowVerifiesService.query({companyId: $stateParams.companyId}).$promise.then(function(flowVerifies){
        $scope.flowVerifies = flowVerifies;
      });

      $scope.publicationFlowVerify = {flow: null};
      if ( !$scope.publication.features.currentCertifyID){
          $scope.publication.features.currentCertifyID =  $scope.publication.features.certifyID;
      }
      if($scope.publication.features.currentCertifyID){
          CompanyPublicationService.getFlowVerify({companyId: $stateParams.companyId, publicationId: $stateParams.publicationId, publicationsVerifyId: $scope.publication.features.currentCertifyID}).$promise.then(function(publicationFlowVerify){
            $scope.publicationFlowVerify = publicationFlowVerify;
          });
      }

      $scope.savePublicationFlowVerify = function(){
        CompanyPublicationService.createFlowVerify({companyId: $stateParams.companyId, publicationId: $stateParams.publicationId}, $scope.publicationFlowVerify).$promise.then(function(publicationFlowVerify) {
          $scope.publicationFlowVerify = publicationFlowVerify;
          if(!$scope.publication.extra.flowCertificates){
            $scope.publication.extra.flowCertificates = [];
          }
          $scope.publication.extra.flowCertificates.push({
            flowId: publicationFlowVerify.id,
            certificates : [],
            signDone : false
          });
          if(!$scope.publication.features.certifyID){
            $scope.publication.features.certifyID = publicationFlowVerify.id;
          }else{
            $scope.publication.features.certifyID += ', ' + publicationFlowVerify.id;
          }
          $scope.publication.features.currentCertifyID = publicationFlowVerify.id;
          $scope.savePublication($scope.publication);
          growl.addSuccessMessage($translate.instant('flow.set-certify-flow-to-object-success'));
        }, function(err) {
          if(err.status === 400){
            growl.addErrorMessage(err.data);
          }else{
            growl.addErrorMessage($translate.instant('flow.set-certify-flow-to-object-failure'));
          }
        });
      };

      $scope.$on("files-uploaded", function() {
        CompanyPublicationFileService.query({
          companyId:     $stateParams.companyId,
          publicationId: $stateParams.publicationId,
          limit:         1
        }).$promise.then(function(files) {
          $scope.currentFile = files[0] || false;
          if ($scope.currentFile) {
            $scope.$broadcast('fileProcessed', $scope.currentFile);
            $scope.$emit('publicationSaved');
          }
        });
      });

      break;
  }
}

CompanyPublicationDetailCtrl.resolve = {
  data: [
  '$q',
  '$stateParams',
  'publication',
  'company',
  'CompanyPublicationFileService',
  'CompanyPublicationService',
  'CompanyPublicationPlantService',
  'CompanyProductsService',
  'CompanyCustomersService',
  'CompanyPublicationOrderService',
  'CompanyChecklistService',
  'CompanyGroupService',
  'CompanyPublicationCompanyOrderService',
  'CompanyPublicationCompanyOrderSubcriptionService',
  'CompanyPublicationCompanyInvestigationService',
  'CompanySettingInvestigationUsersService',
  'CompanySettingInvestigationTemplatesService',
  'CompanyInvestigationPagesService',
  'CompanyPublicationBlogService',
  'CompanyLogoService',
  function($q,
    $stateParams,
    publication,
    company,
    CompanyPublicationFileService,
    CompanyPublicationService,
    CompanyPublicationPlantService,
    CompanyProductsService,
    CompanyCustomersService,
    orderService,
    checklistService,
    CompanyGroupService,
    publicationCompanyOrderService,
    publicationCompanyOrderSubcriptionService,
    CompanyPublicationCompanyInvestigationService,
    CompanySettingInvestigationUsersService,
    CompanySettingInvestigationTemplatesService,
    CompanyInvestigationPagesService,
    CompanyPublicationBlogService,
    CompanyLogoService) {
    var order = false;
    switch(publication.type) {
      case 'CUSTOMER_ADAPTION':
      case 'SK3_FOLDER':
      var checklists = checklistService.query({
          companyId: $stateParams.companyId,
          relativeID: $stateParams.publicationId
        }).$promise;

      var files = CompanyPublicationFileService.query({
        companyId:     $stateParams.companyId,
        publicationId: $stateParams.publicationId,
        limit:         22,
        offset:        ($stateParams.page|0) * 21,
        q:             $stateParams.searchFile || "",
        searchAble: true
      }).$promise;

      return $q.all([checklists, files]).then(function(data) {
        return {
          checklists : data[0],
          files      : data[1]
        };
      });
      case 'ALBUM':
      var checklists = checklistService.query({
          companyId: $stateParams.companyId,
          relativeID: $stateParams.publicationId
        }).$promise;

      var files = CompanyPublicationFileService.query({
        companyId:     $stateParams.companyId,
        publicationId: $stateParams.publicationId,
        limit:         22,
        visible:       $stateParams.showInvisible === "true" ? "false" : "true",
        offset:        ($stateParams.page|0) * 21,
        q:             $stateParams.searchFile || "",
        searchAble: true
      }).$promise;

      return $q.all([checklists, files]).then(function(data) {
        return {
          checklists : data[0],
          files      : data[1]
        };
      });

      case 'PUBLICATION_GROUP':
        var currentFile = CompanyPublicationFileService.query({
          companyId:     $stateParams.companyId,
          publicationId: $stateParams.publicationId,
          limit:         1
        }).$promise.then(function(files) {
          return files[0] || false;
        });
        var children    = CompanyPublicationService.query({
          companyId: $stateParams.companyId,
          parentId:  $stateParams.publicationId,
          limit:     200
        }).$promise;

        var customer = false;
        if (publication.features.currentCustomerId) {
          customer = CompanyCustomersService.get({
            companyId: $stateParams.companyId,
            publication: $stateParams.publicationId,
            customerId: publication.features.currentCustomerId
          }).$promise;
        }

        return $q.all([currentFile, children, customer]).then(function(data) {
          return {
            currentFile: data[0],
            children:    data[1],
            customer:    data[2]
          };
        });

      case 'FOLDER':
        checklists = checklistService.query({
          companyId: $stateParams.companyId,
          relativeID: $stateParams.publicationId
        }).$promise;

        children = CompanyPublicationService.query({
          companyId: $stateParams.companyId,
          parentId:  $stateParams.publicationId,
          limit:     200
        }).$promise;

        files = CompanyPublicationFileService.query({
          companyId:     $stateParams.companyId,
          publicationId: $stateParams.publicationId,
          limit:         22,
          visible:       $stateParams.showInvisible === "true" ? "false" : "true",
          offset:        ($stateParams.page|0) * 21,
          q:             $stateParams.searchFile || "",
          searchAble: true
        }).$promise;

        if (publication.features.currentCustomerId) {
          customer = CompanyCustomersService.get({
            companyId: $stateParams.companyId,
            publication: $stateParams.publicationId,
            customerId: publication.features.currentCustomerId
          }).$promise;
        }

        return $q.all([files, children, checklists, customer]).then(function(data){
          return {
            files: data[0],
            children: data[1],
            checklists: data[2],
            customer: data[3]
          };
        });

      case 'NOTE':
        checklists = checklistService.query({
          companyId: $stateParams.companyId,
          relativeID: $stateParams.publicationId
        }).$promise;

        children = CompanyPublicationService.query({
          companyId: $stateParams.companyId,
          parentId:  $stateParams.publicationId,
          limit:     200
        }).$promise;

        var logoPdf = CompanyLogoService.get({
          companyId: $stateParams.companyId,
          type:  'pdf'
        }).$promise;

        return $q.all([checklists, children, logoPdf]).then(function(data){
          return {
            checklists: data[0],
            children: data[1],
            logoPdf: data[2]
          };
        });
      case 'KEYPASS':
        break;
      case 'WALL':
        break;

      case 'ENGINE_MODEL':
        var file = CompanyPublicationFileService.query({
          companyId:     $stateParams.companyId,
          publicationId: $stateParams.publicationId,
          limit:         1,
          visible:       "true"
        }).$promise.then(function(files) {
          return files[0] || false;
        });
        return file;

      case 'PLANT':
        var plantData = false;
        if (publication.features.currentPlantId) {
          plantData = CompanyPublicationPlantService.get({companyId: $stateParams.companyId,
            publicationId: $stateParams.publicationId,
            plantId: publication.features.currentPlantId
          }).$promise;
        }

        file = CompanyPublicationFileService.query({
          companyId:     $stateParams.companyId,
          publicationId: $stateParams.publicationId,
          limit:         1
        }).$promise.then(function(files) {
          return files[0] || false;
        });

        return $q.all([file, plantData]).then(function(resp){
          return {
            currentFile: resp[0],
            plant: resp[1]
          };
        });

      case 'ORDER':
        var deferred = $q.defer();
        if (publication.features.currentOrderId) {
            orderService.get({
            companyId: $stateParams.companyId,
            publicationId: $stateParams.publicationId
          }).$promise.then(function(resp){
            deferred.resolve(resp);
          }, function(){
            deferred.resolve(false);
          });
        } else {
          deferred.resolve(false);
        }

        return deferred.promise;

      case 'COMPANY_ORDER':
        files = CompanyPublicationFileService.query({
          companyId:     $stateParams.companyId,
          publicationId: $stateParams.publicationId,
          limit:         22,
          visible:       $stateParams.showInvisible === "true" ? "false" : "true",
          offset:        ($stateParams.page|0) * 21,
          q:             $stateParams.searchFile || "",
          searchAble: true
        }).$promise;

        if (publication.features.currentCompanyOrderId) {
          order =  false;
        }

        return $q.all([files, order]).then(function(data) {
          return {
            files: data[0],
            order: data[1]
          };
        });
      case 'ORDER_SUBCRIPTION':
        files = CompanyPublicationFileService.query({
          companyId:     $stateParams.companyId,
          publicationId: $stateParams.publicationId,
          limit:         22,
          visible:       $stateParams.showInvisible === "true" ? "false" : "true",
          offset:        ($stateParams.page|0) * 21,
          q:             $stateParams.searchFile || "",
          searchAble: true
        }).$promise;

        children = CompanyPublicationService.query({
          companyId: $stateParams.companyId,
          parentId:  $stateParams.publicationId,
          type: 'ORDER_SUBCRIPTION',
          limit:     200
        }).$promise;

        if (publication.features.currentCompanyOrderId) {
          order =  false;
        }

        return $q.all([files, order, children]).then(function(data) {
          return {
            files: data[0],
            order: data[1],
            children: data[2]
          };
        });
      case 'BLOG':
        return CompanyPublicationBlogService.query({
          companyId: $stateParams.companyId,
          publicationId: $stateParams.publicationId,
          limit:         22,
          offset:        ($stateParams.page|0) * 21
        }).$promise;

      case 'INVESTIGATION':
        var invesUsersUtsatt = CompanyPublicationCompanyInvestigationService.queryUsersInvestigation({
          companyId: $stateParams.companyId,
          publicationId: $stateParams.publicationId,
          limit: 100,
          offset: 0,
          type: 'UTSATT'
        }).$promise;

        var invesUsersMissTankt = CompanyPublicationCompanyInvestigationService.queryUsersInvestigation({
          companyId: $stateParams.companyId,
          publicationId: $stateParams.publicationId,
          limit: 100,
          offset: 0,
          type: 'MISS_TANKT'
        }).$promise;

        var invesUsersEngagerad = CompanyPublicationCompanyInvestigationService.queryUsersInvestigation({
          companyId: $stateParams.companyId,
          publicationId: $stateParams.publicationId,
          limit: 100,
          offset: 0,
          type: 'ENGAGERAD'
        }).$promise;

        var invesUsersAnvarig = CompanyPublicationCompanyInvestigationService.queryUsersInvestigation({
          companyId: $stateParams.companyId,
          publicationId: $stateParams.publicationId,
          limit: 100,
          offset: 0,
          type: 'ANVARIG'
        }).$promise;

        var invesUsersBetslut = CompanyPublicationCompanyInvestigationService.queryUsersInvestigation({
          companyId: $stateParams.companyId,
          publicationId: $stateParams.publicationId,
          limit: 100,
          offset: 0,
          type: 'BETSLUT'
        }).$promise;

        var investigationInfors = CompanyPublicationCompanyInvestigationService.queryInvestigationInfors({
          companyId: $stateParams.companyId,
          publicationId: $stateParams.publicationId,
          limit: 100,
          offset: 0,
          type: 'REDOGO'
        }).$promise;

        var investigationSanmanInfors = CompanyPublicationCompanyInvestigationService.queryInvestigationInfors({
          companyId: $stateParams.companyId,
          publicationId: $stateParams.publicationId,
          limit: 100,
          offset: 0,
          type: 'SANMAN'
        }).$promise;

        var investigationBetslutInfors = CompanyPublicationCompanyInvestigationService.queryInvestigationInfors({
          companyId: $stateParams.companyId,
          publicationId: $stateParams.publicationId,
          limit: 1,
          offset: 0,
          type: 'BETSLUT'
        }).$promise;

        var engageradChecklists = checklistService.query({
          companyId: $stateParams.companyId,
          relativeID: $stateParams.publicationId,
          relativeType: 'INVESTIGATON_ENGAGERAD'
        }).$promise;

        var anvarigChecklists = checklistService.query({
          companyId: $stateParams.companyId,
          relativeID: $stateParams.publicationId,
          relativeType: 'INVESTIGATON_ANVARIG'
        }).$promise;

        var portals = CompanyGroupService.query({
          companyId: $stateParams.companyId, 
          all: true, 
          type: 'VISIBLE'}).$promise;

        var investigationUsers = CompanySettingInvestigationUsersService.query({
          companyId: $stateParams.companyId, 
          limit: 1000}).$promise;

        var investigationTemplates = CompanySettingInvestigationTemplatesService.query({
          companyId: $stateParams.companyId, 
          limit: 1000}).$promise;

        var investigationPages = CompanyInvestigationPagesService.query({
          type: 'STEP', 
          blog_type: 'INVESTIGATION',
          offset: 0,
          lang: window.localStorage.language,
          limit: 9}).$promise;

        return $q.all([invesUsersUtsatt, invesUsersMissTankt, invesUsersEngagerad, invesUsersAnvarig, investigationInfors, investigationSanmanInfors, investigationBetslutInfors, 
                      engageradChecklists, anvarigChecklists, invesUsersBetslut, portals, investigationUsers, investigationTemplates, investigationPages]).then(function(data) {
          return {
            invesUsersUtsatt: data[0],
            invesUsersMissTankt: data[1],
            invesUsersEngagerad: data[2],
            invesUsersAnvarig: data[3],
            investigationInfors: data[4],
            investigationSanmanInfors: data[5],
            investigationBetslutInfors: data[6],
            engageradChecklists: data[7],
            anvarigChecklists: data[8],
            invesUsersBetslut: data[9],
            portals: data[10],
            investigationUsers: data[11],
            investigationTemplates: data[12],
            investigationPages: data[13]
          };
        });

      default:
        checklists = checklistService.query({
          companyId: $stateParams.companyId,
          relativeID: $stateParams.publicationId
        }).$promise;

        files = CompanyPublicationFileService.query({
          companyId:     $stateParams.companyId,
          publicationId: $stateParams.publicationId,
          limit:         1
        }).$promise.then(function(files) {
          return files[0] || false;
        });

        return $q.all([checklists, files]).then(function(data){
          return  {
            checklists: data[0],
            files: data[1]
          };
        });
    }
  }],
  translations: ['$translate', function($translate) {
    return $translate([
      'publication.delete-file-failure',
      'publication.delete-file-success',
      'form.product-list.all'
    ]);
  }]
};

module.exports = CompanyPublicationDetailCtrl;

angular.module("dokiv")
  .controller("CompanyPublicationDetailCtrl", CompanyPublicationDetailCtrl);

function isTypeImage() {
  return function(mimetype) {
    switch(mimetype) {
        case 'image/jpeg':
        case 'image/png':
        case 'image/gif':
        case 'image/bmp':
        case 'image/svg+xml':
        case 'image/webp':
          return true;
        default:
          return false;
      }
  };
}

angular.module('dokiv')
  .filter('isTypeImage', isTypeImage);



//////////////////
// WEBPACK FOOTER
// ./scripts/company/publications/CompanyPublicationDetailCtrl.js
// module id = 374
// module chunks = 0